import React from 'react';
import DocumentArchive from '../components/sections/DocumentArchive';
import SEO from '../components/SEO';
import '../styles/Transparencia.css';

const Transparencia: React.FC = () => (
  <div className="transparencia">
    <SEO
      title="Transparência | Patinhas Sem Lar"
      description="Consulte informação de transparência, contas, relatórios e atividade da Patinhas Sem Lar."
      path="/transparencia"
    />
    <DocumentArchive />
  </div>
);

export default Transparencia;
